/*
 * Copyright (c) 2020. Minerva Networks.
 * All rights reserved.
 */

import 'url-search-params-polyfill';
import Vue from 'vue';
import Vuex from 'vuex';
import VueLogger from 'vuejs-logger';
import VueI18n from 'vue-i18n';
import VueCookies from 'vue-cookies';
import VueCarousel from 'vue-carousel';
import Tabs from 'vue-tabs-component';
import includes from 'lodash.includes';
import videoPlayer from 'vue-videojs-player-v7';
import fullscreen from 'vue-fullscreen';
import axios from 'axios';
// import { TrackJS } from 'trackjs';
import VueDragscroll from 'vue-dragscroll';
import 'reset-css/reset.css';
// eslint-disable-next-line
import 'video.js/dist/video-js.css';
import 'animate.css/animate.css';
import VueLocalStorage from 'vue-ls';
import Meta from 'vue-meta';
import './assets/scss/current/style.scss';
// import videojs from 'video.js';
import App from './App.vue';
import router from './router';
import protoStore from './store';
import messages from './assets/i18n/i18n';

const { detect } = require('detect-browser');

const browser = detect();

/* eslint-disable */

(function (i, s, o, g, r, a, m) {
  i['GoogleAnalyticsObject'] = r;
  i[r] = i[r] || function () {
    (i[r].q = i[r].q || []).push(arguments);
  }, i[r].l = 1 * new Date();
  a = s.createElement(o),
    m = s.getElementsByTagName(o)[0];
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

/* eslint-enable */

let conf = false;

const isProduction = process.env.NODE_ENV === 'production';
const env = process.env.NODE_ENV === 'production' ? 'prod' : 'dev';

const loggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
};
Vue.use(Meta);
Vue.use(VueLogger, loggerOptions);
Vue.use(VueDragscroll);
axios.get(`./${env}_2.json`)
  .then((res) => {
    conf = res.data;
    let locale = conf.locale ? conf.locale : navigator.language.split('-')[0];
    if (!includes(conf.locales, locale)) {
      locale = 'en';
    }

    window.ga('create', conf[env].GA, 'auto', 'tok');
    window.ga('tok.set', {
      dimension1: conf.xTokKey,
      dimension2: conf.xTokChannel,
      dimension3: conf.xTokVersion,
      dataSource: 'web',
    });

    Vue.config.productionTip = false;

    Vue.use(VueCookies);
    Vue.use(VueI18n);
    Vue.use(VueCarousel);
    Vue.use(fullscreen);
    Vue.use(Tabs);
    Vue.use(videoPlayer);
    window.TOK_NS = 'alive__';
    const options = {
      namespace: window.TOK_NS,
    };

    Vue.use(VueLocalStorage, options);

    Vue.mixin({
      computed: {
        ...Vuex.mapState(['appName', 'logo', 'widgetMode', 'md', 'env', 'conf']),
        ...Vuex.mapGetters(['isWidget']),
      },
      methods: {
        getCookie(name) {
          const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
          const cookie = v ? v[2] : null;
          return JSON.parse(cookie);
        },
        isStoreValid(ls) {
          const now = new Date().getTime();
          const difference = (now - ls.time) / 1000;
          if (ls && ls.data && difference > 60) {
            return false;
          }
          return true;
        },
      },
    });

    const urlParams = new URLSearchParams(window.location.search);
    window.vpQueryLocale = urlParams.get('locale');
    if (window.vpQueryLocale) locale = window.vpQueryLocale;

    const i18n = new VueI18n({
      locale,
      messages,
    });
    window.app = new Vue({
      router,
      store: protoStore(conf, env, locale),
      i18n,
      render: h => h(App),
    }).$mount('#app');
    const reactionStripeConfig = {
      ADS_URL: conf[env].ADS_URL,
      appid: conf[env].appid,
      service: conf[env].service,
      host: conf[env].host,
      BASE_GROUP_PHOTO_URL: conf[env].BASE_GROUP_PHOTO_URL,
      BASE_SHARE_URL: `${conf[env].BASE_SHARE_URL + conf[env].appid}/${window.app.$t('lang')}?id=`,
      TWITTER_TEXT: encodeURI(window.app.$t('TWITTER_TEXT')),
      browser,
    };
    window.app.$store.commit('setReactionStripeConfig', reactionStripeConfig);
  })
  .catch((error) => {
    console.dir(error);
  });
